import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import * as AOS from 'aos';
import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';
@Component({
  selector: 'app-technology-training',
  templateUrl: './technology-training.component.html',
  styleUrls: ['./technology-training.component.css']
})
export class TechnologyTrainingComponent {
  baseUrl = Constants.baseUrl;
  isBrowser: boolean = false;


  constructor(private titleService: Title, @Inject(PLATFORM_ID) private platformId: any, private _renderer2: Renderer2, private seoService: SeoService,
    @Inject(DOCUMENT) private _document: Document, private metaService: Meta) { this.isBrowser = isPlatformBrowser(this.platformId); }
  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
  {
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/technology-training/"
  },
  "headline": "Technology Training | Maganti IT",
  "description": "Explore internships that are springboards for your dynamic career. We're always on the lookout for passionate individuals who're willing to expand their horizons of capabilities.",
  "image": "https://mitresource.com/assets/images/techtraining_images/trainingimage1.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-10-24"
}`;

    this._renderer2.appendChild(this._document.head, script);

    if (this.isBrowser) {
      AOS.init({ disable: 'mobile', duration: 2000, delay: 500, });

      AOS.refresh;
    }

    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();

  }

  private setTitleAndMetaTags(): void {
    // Set page title
    this.titleService.setTitle('Technology Training');

    // Set meta tags
    this.metaService.addTags([
      { name: 'description', content: "Explore internships that are springboards for your dynamic career. We're always on the lookout for passionate individuals who're willing to expand their horizons of capabilities." },
      { property: 'og:type', content: 'website' },
      { property: 'link:icon', content: '/assets/images/banners/mit-favicon.png' },
      { property: 'og:title', content: 'Technology Training' },
      { property: 'og:url', content: 'https://mitresource.com/technology-training/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/application/application-bulidimage.png' },
      { property: 'og:description', content: "Explore internships that are springboards for your dynamic career. We're always on the lookout for passionate individuals who're willing to expand their horizons of capabilities." },
    ]);
  }
}
